import { gql } from '@apollo/client';

export const GET_ADMIN_CONSOLE_CERTIFICATE_TEMPLATES = gql`
  query GetAdminConsoleCertificateTemplates {
    vm {
      certificateTemplates {
        certificateTemplateId
        name
        levelCount
        design
      }
    }
  }
`;
